/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.05.2016.
 */
import CLPP from './clpp';

export default CLPP;



// WEBPACK FOOTER //
// ./src/containers/Player/CLPP/index.js